import { toolbarHeightVar } from '@sales-center/common'
import { Theme } from '@mui/material/styles/createTheme'

const drawerWidth: string = '178px'
// drawerPaper is `position: fixed`, so it repeats the no-select rules instead of
// inheriting them, and `touchAction: 'pan-y'` lets a tap-and-hold scroll the nav
// immediately rather than start a text selection.
export const getStyles = (theme: Theme) => ({
  menuButton: {
    textAlign: 'right',
    verticalAlign: 'middle',
    height: '47px',
    width: '47px',
    '& > button': {
      height: '47px',
      width: '47px',
    },
  },

  drawer: {
    flexShrink: 0,
    width: drawerWidth,
    whiteSpace: 'nowrap',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },

  drawerPaper: {
    position: 'fixed',
    top: 0,
    left: 0,
    paddingTop: toolbarHeightVar,
    width: drawerWidth,
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: '100vh',
    overflow: 'hidden',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
    touchAction: 'pan-y',
    overscrollBehavior: 'contain',
    '& > button': {
      color: theme.palette.primary.contrastText,
    },
    '@supports (height: 100dvh)': {
      height: '100dvh',
    },
  },

  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  },

  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '47px',
  },

  menuBtnContainer: { textAlign: 'right' },

  iconContainer: {
    width: 'auto',
    height: '47px',
    color: theme.palette.primary.contrastText,
    flexDirection: 'row',
    display: 'flex',
  },

  subMenuList: {
    fontSize: '14px',
    '& > div': {
      borderTop: '1px solid #d1d1d6',
      height: '50px',
    },
    '& > div:first-child': {
      borderTop: 'unset',
    },
  },

  subMenuHeader: {
    color: theme.palette.primary.main,
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
    height: '50px',
  },

  subMenuListItem: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    marginLeft: theme.spacing(0.9),
    paddingLeft: theme.spacing(0.4),
  },

  subMenuListItemSelected: {
    borderLeft: `3px solid ${theme.palette.primary.main}`,
  },

  subMenuListItemText: {},

  subMenuListItemTextSelected: {
    fontFamily: 'Source Sans Pro Bold',
  },
})
